import { createHead as createClientHead } from '@unhead/vue/client'
import { createHead as createServerHead } from '@unhead/vue/server'

function createRenderingHead (isServer: true): ReturnType<typeof createServerHead>
function createRenderingHead (isServer: false, document?: Document): ReturnType<typeof createClientHead>
function createRenderingHead (isServer: boolean, document?: Document) {
  const isSsrBuild = import.meta.env?.SSR ?? isServer
  return isSsrBuild ? createServerHead() : createClientHead({ document })
}

export { createRenderingHead }
